/**
 * Logic Necessary for the CPE
 * List View
 * Author: Imarc 2019
 */

import classToggle from '@inkwell/scripts/modules/classtoggle';

const options = document.querySelector('[data-options-details]');
const resultsFiltersForm = document.querySelector('#results-filters');

classToggle({
    elementClass: '.js-group',
    triggerClass: '.js-groupTrigger',
    toggleClass: '-open',
});

const addClearListeners = () => {
    const appliedFiltersElement = document.querySelector('#applied-filters');
    const clearButtons = [...appliedFiltersElement.querySelectorAll('[data-clear]')];

    clearButtons.forEach(button => {
        button.addEventListener(
            'click',
            function applyEventListener(event) {
                event.preventDefault();
                let formElement = resultsFiltersForm.querySelector(
                    `[name="${button.name}"]:not([type="hidden"])`
                );

                if (!formElement) {
                    formElement = resultsFiltersForm.querySelector(
                        `[data-name="${button.name}"]`
                    );
                }

                if ('slimselect' in formElement.dataset) {
                    const option = formElement.querySelector(
                        `option[value="${button.value}"]`
                    );
                    const selectedValues = formElement.slimSelect.selected();
                    const filteredValues = selectedValues.filter(
                        value => value !== button.value
                    );
                    formElement.slimSelect.set(filteredValues);
                    option.removeAttribute('selected');
                    button.remove();
                    resultsFiltersForm.dispatchEvent(new Event('change'));
                    return;
                }

                if ('flatpickr' in formElement.dataset) {
                    const inputWrapper = formElement.closest('.js-dateRange');
                    const dateBefore = inputWrapper.querySelector('.js-dateBefore');
                    const dateAfter = inputWrapper.querySelector('.js-dateAfter');
                    dateBefore.value = null;
                    dateAfter.value = null;
                    formElement.flatpickr.clear();
                    button.remove();
                    resultsFiltersForm.dispatchEvent(new Event('change'));
                    return;
                }

                if (formElement.type === 'checkbox') {
                    const associatedCheckbox = resultsFiltersForm.querySelector(
                        `input[name="${button.name}"][value="${button.value}"]`
                    );
                    associatedCheckbox.checked = false;
                    associatedCheckbox.removeAttribute('checked');
                    button.remove();
                    resultsFiltersForm.dispatchEvent(new Event('change'));
                    return;
                }

                formElement.value = null;

                button.remove();
                resultsFiltersForm.dispatchEvent(new Event('change'));
            },
            false
        );
    });
};

const applyFilterCounts = filterCounts => {
    Object.entries(filterCounts).forEach(([name, filterData]) => {
        const selectElement = document.querySelector(`select[name^="f[${name}]"]`);
        const checkboxes = [...document.querySelectorAll(`[name="f[${name}][]"]`)];

        if (selectElement) {
            const closestParent = selectElement.closest('.js-select');
            const optionElements = [...closestParent.querySelectorAll('.ss-option')];
            const optionList = closestParent.querySelector('.ss-list');

            const { data } = selectElement.slimSelect;
            const dataToUpdate = data.data.map(({ text, value }) => ({ text, value }));
            const dataWithCounts = dataToUpdate.map(countDataObject => {
                const associatedCountDataObject = filterData.data.find(
                    ({ value }) => value === countDataObject.value
                );

                return {
                    text: `${countDataObject.text} <strong>(${associatedCountDataObject.subtotal})</strong>`,
                    value: countDataObject.value,
                    count: associatedCountDataObject.subtotal,
                };
            });

            const elementsSorted = optionElements
                .map(optionElement => {
                    if (optionElement.classList.contains('ss-disabled')) {
                        return optionElement;
                    }
                    
                    if (!('originalName' in optionElement.dataset)) {
                        optionElement.dataset.originalName = optionElement.innerText;
                    }

                    const associatedDataWithCountObject = dataWithCounts.find(
                        dataWithCount =>
                            dataWithCount.text.includes(
                                optionElement.dataset.originalName
                            )
                    );

                    optionElement.innerHTML = associatedDataWithCountObject.text;
                    optionElement.dataset.count = associatedDataWithCountObject.count;

                    return optionElement;
                })
                .sort((a, b) => Number(b.dataset.count) - Number(a.dataset.count));

            optionList.innerHTML = '';
            elementsSorted.forEach(element => optionList.appendChild(element));
        } else if (checkboxes.length) {
            checkboxes.forEach(checkboxElement => {
                if (typeof filterData.data !== 'undefined') {
                    const associatedCountDataObject = filterData.data.find(
                        ({ value }) => value === checkboxElement.value
                    );

                    const label = checkboxElement.closest('label');

                    if (label) {
                        const textSpan = label.querySelector('span');

                        if (!('originalText' in label.dataset)) {
                            label.dataset.originalText = textSpan.textContent;
                        }

                        const labelElement = label.querySelector('span');
                        labelElement.innerHTML = `${label.dataset.originalText} <strong>(${associatedCountDataObject.subtotal})</strong>`;
                    }
                }
            });
        }
    });
};

addClearListeners();
applyFilterCounts(window.filterCounts);

const addToggleToListItems = () => {
    document.querySelectorAll('[data-cpe-list-item]').forEach(item => {
        item.addEventListener('click', event => {
            event.currentTarget.classList.toggle('-expanded');
        });
    });
};

addToggleToListItems();

if (options) {
    classToggle({
        elementClass: '[data-options-details]',
        triggerClass: '[data-options-toggle]',
        toggleClass: '-expanded',
    });
}

document.body.addEventListener('htmx:load', ({ detail }) => {
    if (detail.elt.id === 'applied-filters') {
        addClearListeners();
        applyFilterCounts(window.filterCounts);
    }

    if (detail.elt.id === 'results') {
        addToggleToListItems();
    }

    if (detail.elt.id === 'groups') {
        classToggle({
            elementClass: '.js-group',
            triggerClass: '.js-groupTrigger',
            toggleClass: '-open',
        });
    }
});

document.body.addEventListener('htmx:beforeRequest', event => {
    if (
        event.detail.requestConfig.triggeringEvent.explicitOriginalTarget.hasAttribute(
            'data-clear'
        )
    ) {
        event.preventDefault();
    }
});
